import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';

import { memberLabel } from './format';
import PickPopover from './PickPopover';

const SUMMARY_CHARS = 20;

export function pickSummary(picked: Array<string>): { head: string; rest: number } {
  if (!picked.length) return { head: 'All', rest: 0 };
  const two = picked.slice(0, 2).join(', ');
  const head = picked.length > 1 && two.length <= SUMMARY_CHARS ? two : picked[0];
  return { head, rest: picked.length - (head === two ? Math.min(2, picked.length) : 1) };
}

export default function MultiPick({
  label,
  options,
  picked,
  onPick,
  single = false,
  onRemove,
}: {
  label: string;
  options: Array<string>;
  picked: Array<string>;
  onPick?: (picked: Array<string>) => void;
  single?: boolean;
  onRemove?: () => void;
}) {
  const summary = pickSummary(picked.map(memberLabel));
  return (
    <Box className={`chip${picked.length ? ' set' : ''}`} component="span">
      {label}
      <Box className="cv" component="span">
        <Box className="cv-head" component="span">
          {summary.head}
        </Box>
        {summary.rest ? (
          <Box className="cv-rest" component="span">
            +{summary.rest}
          </Box>
        ) : null}
      </Box>
      {onPick ? (
        <PickPopover
          label={label}
          onPick={onPick}
          options={options.map((value) => ({ value, label: memberLabel(value) }))}
          overlay
          picked={picked}
          single={single}
        >
          {null}
        </PickPopover>
      ) : null}
      {onRemove ? (
        <IconButton aria-label={`Remove the ${label} filter`} onClick={onRemove} size="small" sx={{ zIndex: 1 }}>
          <CloseIcon sx={{ fontSize: 12 }} />
        </IconButton>
      ) : null}
    </Box>
  );
}
